import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardIcon,
  CardTitle,
} from "components/ui/card";
import { cn } from "@/lib/utils";
import { ArrowRight, type LucideIcon } from "lucide-react";
import { useHistory } from "react-router-dom";

export interface QuickAction {
  id: string;
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
  color: string;
}

/**
 * A single home-page quick-action card. Navigates on click, unless `editing`
 * is set — in edit mode the card is inert so drag/resize/remove interactions
 * never trigger navigation.
 */
export const QuickActionCard = ({
  action,
  editing = false,
}: {
  action: QuickAction;
  editing?: boolean;
}) => {
  const history = useHistory();
  const Icon = action.icon;

  return (
    <Card
      className={cn(
        "group relative overflow-hidden bg-card h-full",
        !editing && "hover:bg-muted cursor-pointer",
      )}
      onClick={editing ? undefined : () => history.push(action.href)}
    >
      <CardHeader>
        <CardIcon
          variant="default"
          className={`${action.color} text-background p-2.5 rounded-lg`}
        >
          <Icon className="size-5" />
        </CardIcon>
        <CardTitle>{action.title}</CardTitle>
      </CardHeader>
      <CardContent>
        <CardDescription>{action.description}</CardDescription>
        {!editing && (
          <ArrowRight className="absolute bottom-4 right-4 size-4 text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity" />
        )}
      </CardContent>
    </Card>
  );
};
